import React, {Component} from 'react'

class Content extends Component {
	constructor(props) {
		super(props)

		this.state = {}

	}

	componentDidMount() {
		
	}

	componentWillReceiveProps(newProps) {
		
	}

	render() {

		return (
			// <section className="hsg-dashboard-container" style={{minHeight: this.props.dim.height}}>
			<section className="hsg-dashboard-container" style={{}}>

				<section>
					<div
						style={{
							marginTop: 100,
							textAlign: 'center',
							fontSize: 16,
							color: '#666666'
						}}
					>
						HSG Content Website.
					</div>
				</section>

			</section>
		)
	}

}

export default Content
